











































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  props: {
    datos: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
    proveedor: {
      name: '',
      ctaContable: '',
      descripcion: '',
      observaciones: '',
      rfc: '',
    },
    loading: false,
    Bancos: [],
  }),
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getImpuesto']),
    modeloProveedor() {
      return {
        name: '',
        ctaContable: '',
        descripcion: '',
        observaciones: '',
        creationDateTime: '',
        creationUsername: '',
        lastModificationDateTime: '',
        lastModificationUsername: '',
      };
    },
    async loadData() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch('getBancos');
        this.Bancos = result;
        console.debug('Bancos: %o', this.Bancos);
      } catch (e) {
        console.error(e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async AgregarProveedor() {
      const isConceptoValid = this.validateProveedor(this.proveedor);
      if (isConceptoValid) {
        try {
          this.loading = true;
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          // this.proveedor.adeudo = !this.proveedor.adeudo;
          // this.proveedor.creationDateTime = this.$moment().format();
          // this.proveedor.creationUsername = this.$store.getters.getUsername;
          const proveedor = this.proveedor;
          const datos = {admin, condo, proveedor};
          console.log('DATOS-Provee: %o', datos);
          const result = await this.$store.dispatch('addProveedor', {datos} );
          console.debug('Respuesta addProveedor: %o', result);
          this.$toast.success('Proveedor agregado');
        } catch (e) {
          console.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.loading = false;
        this.openDialog = false;
        this.$emit('reload', {});
      }
      return;
    },
    validateProveedor(proveedor) {
      if (typeof(proveedor.name) !== 'string' || proveedor.name.length === 0) {
        this.$toast.error('Introduzca un nombre de proveedor');
        return false;
      }
      // if (typeof(concepto.ctaContable) !== 'string' || concepto.ctaContable.length === 0) {
      //   this.$toast.error('Introduzca una cuenta contable');
      //   return false;
      // }
      // if (typeof(proveedor.unidadMedida) !== 'string' || proveedor.unidadMedida.length === 0) {
      //   this.$toast.error('Seleccione una unidad de medida');
      //   return false;
      // }
      // if (typeof(proveedor.tipo) !== 'string' || proveedor.tipo.length === 0) {
      //   this.$toast.error('Seleccione un tipo');
      //   return false;
      // }
      // if (Object.keys(proveedor.impuesto).length === 0) {
      //   this.$toast.error('Seleccione un impuesto');
      //   return false;
      // }
      return true;
    },
  },
  watch: {
    openDialog() {
      const arregloProveedores = JSON.parse(JSON.stringify(this.datos));
      this.proveedor = arregloProveedores[0];
      console.debug('PROVEEDORES: ', this.proveedor);
    },
  },
});
